import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import sedan from "Assets/Images/Sedan.png"
import suv from "Assets/Images/Suv.png"
import crossover from "Assets/Images/crossover.png"
import hatchback from "Assets/Images/Hatchback.png"
import traveller from "Assets/Images/traveller.png"

const features = [
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
      >
        <path d="M17 8h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2v4l-4-4H9a2 2 0 0 1-2-2v-1" />
        <path d="M3 4h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9l-4 4V6a2 2 0 0 1 2-2z" />
      </svg>
    ),
    title: "Flexible Pick-Up & Drop-Off",
    desc: "Choose locations and times that suit your schedule. Modern vehicles with the latest features.",
    bg: "from-emerald-50 to-teal-50",
    border: "border-emerald-100",
    iconBg: "bg-emerald-500",
    shadow: "hover:shadow-emerald-100",
    glow: "emerald",
  },
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
      >
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
        <line x1="12" y1="12" x2="12" y2="16" />
        <line x1="10" y1="14" x2="14" y2="14" />
      </svg>
    ),
    title: "Business Travel Solutions",
    desc: "Special rates and services for businesses. Streamlined invoicing for all business rentals.",
    bg: "from-violet-50 to-purple-50",
    border: "border-violet-100",
    iconBg: "bg-violet-500",
    shadow: "hover:shadow-violet-100",
    glow: "violet",
  },
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4l3 3" />
      </svg>
    ),
    title: "Flexible Rental Periods",
    desc: "Rent by the hour, day, week, or month. Availability for spontaneous or urgent needs.",
    bg: "from-cyan-50 to-sky-50",
    border: "border-cyan-100",
    iconBg: "bg-cyan-500",
    shadow: "hover:shadow-cyan-100",
    glow: "cyan",
  },
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: "Safe & Insured Rides",
    desc: "All vehicles fully insured and regularly inspected. Drive with complete peace of mind.",
    bg: "from-rose-50 to-pink-50",
    border: "border-rose-100",
    iconBg: "bg-rose-500",
    shadow: "hover:shadow-rose-100",
    glow: "rose",
  },
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
      >
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
    title: "Wide Vehicle Range",
    desc: "From sedans to luxury SUVs, electric vehicles, and minivans. We have it all for you.",
    bg: "from-amber-50 to-yellow-50",
    border: "border-amber-100",
    iconBg: "bg-amber-500",
    shadow: "hover:shadow-amber-100",
    glow: "amber",
  },
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
      >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5 19.79 19.79 0 0 1 1.61 4.93 2 2 0 0 1 3.58 2.72h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 17z" />
      </svg>
    ),
    title: "24/7 Customer Support",
    desc: "Round-the-clock assistance from our expert team. We're here whenever you need us.",
    bg: "from-indigo-50 to-blue-50",
    border: "border-indigo-100",
    iconBg: "bg-indigo-500",
    shadow: "hover:shadow-indigo-100",
    glow: "indigo",
  },
];

const cars = [
 
  {
    name: "Tempo-Traveller",
    tag: null,
    img: traveller,
    //img: "https://dreamstour.dreamstechnologies.com/html/assets/img/cars/car-05.png",
    color: "#8b5cf6",
  },
   {
    name: "Crossover",
    tag: null,
    img: crossover,
    //img: "https://dreamstour.dreamstechnologies.com/html/assets/img/cars/car-03.png",
    color: "#f59e0b",
  },
  {
    name: "Hatchback",
    tag: "null",
    img: hatchback,
    //img: "https://dreamstour.dreamstechnologies.com/html/assets/img/cars/car-04.png",
    color: "#3b82f6",
  },
  {
    name: "Sedan",
    tag: null,
    img: sedan,
    //img: "https://dreamstour.dreamstechnologies.com/html/assets/img/cars/car-01.png",
    color: "#6366f1",
  },
  {
    name: "SUV",
    tag: null,
    img: suv,
    //img: "https://dreamstour.dreamstechnologies.com/html/assets/img/cars/car-02.png",
    color: "#10b981",
  },
];

// Duplicate for seamless loop
const allCars = [...cars, ...cars, ...cars];

export default function CarRentalSection() {
  const trackRef = useRef(null);
  const [paused, setPaused] = useState(false);
  const positionRef = useRef(0);
  const rafRef = useRef(null);
  const speed = 0.6;
  const [hovered, setHovered] = useState(null);
  // const [cabsData, setCabsData] = useState([]);

  // const fetchCabData = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/cab/all-cab`,
  //     );

  //     setCabsData(response?.data?.data);
  //     //console.log(response.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   fetchCabData();
  // }, []);

  const navigate = useNavigate()

  useEffect(() => {
  const track = trackRef.current;

  const animate = () => {
    if (!paused && track) {
      positionRef.current -= speed;

      const firstSetWidth = track.scrollWidth / 3;

      if (Math.abs(positionRef.current) >= firstSetWidth) {
        positionRef.current = 0;
      }

      track.style.transform = `translateX(${positionRef.current}px)`;
    }

    rafRef.current = requestAnimationFrame(animate);
  };

  rafRef.current = requestAnimationFrame(animate);

  return () => cancelAnimationFrame(rafRef.current);
}, [paused]);

  return (
    <div className="pt-16 px-4 sm:px-8 lg:px-20 overflow-hidden">
      {/* Background decorations */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl" />
        <div className="absolute top-1/3 -right-40 w-80 h-80 bg-violet-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-1/3 w-96 h-64 bg-cyan-500/8 rounded-full blur-3xl" />
      </div>

    
      <div className="relative mx-auto">
        {/* ─── Feature Cards ─── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 pb-10">
          {features.map((f, i) => (
            <div
              key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              className={`
                group relative rounded-2xl border bg-gradient-to-br ${f.bg} ${f.border}
                p-5 overflow-hidden cursor-pointer
                transition-all duration-400
                hover:-translate-y-1.5 hover:shadow-xl ${f.shadow}
              `}
            >
              {/* Top row: title left, icon right — exactly like image */}
              <div className="flex items-start justify-between gap-2 mb-3">
                <h3 className="text-slate-800 font-bold text-sm leading-snug tracking-tight flex-1">
                  {f.title}
                </h3>
                {/* Icon circle — top right like the image */}
                <div
                  className={`
                  flex-shrink-0 w-10 h-10 rounded-full ${f.iconBg} text-white
                  flex items-center justify-center shadow-md
                  transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6
                `}
                >
                  {f.icon}
                </div>
              </div>

              {/* Description */}
              <p className="text-slate-500 text-xs leading-relaxed">{f.desc}</p>

              {/* Hover glow */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-400 bg-gradient-to-br from-white/30 to-transparent rounded-2xl pointer-events-none" />

              {/* Decorative bg blob */}
              <div
                className={`
                absolute -bottom-4 -right-4 w-20 h-20 ${f.iconBg}
                opacity-5 rounded-full blur-2xl
                transition-all duration-500 group-hover:opacity-15 group-hover:scale-150
              `}
              />

              {/* Bottom accent slide-in line */}
              <div
                className={`
                absolute bottom-0 left-0 h-0.5 w-0 group-hover:w-full
                transition-all duration-500 ${f.iconBg} rounded-b-2xl
              `}
              />
            </div>
          ))}
        </div>
      </div>

      {/* ─── Trending Categories Header ─── */}
      <div className="text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-rose-500/60" />
          <div className="flex items-center gap-1.5">
            <svg
              className="w-5 h-5 text-rose-400"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M3 17l4-8 4 4 4-6 4 4" />
              <path d="M21 7l-4 4" />
            </svg>
            <span className="text-rose-400 text-xs font-semibold uppercase tracking-widest">
              Trending Now
            </span>
          </div>
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-rose-500/60" />
        </div>

        <h2 className="text-2xl md:text-4xl font-black tracking-tighter mb-4">
          Trending <span className="">Cab Types</span>
        </h2>
        <p className="text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          Gaining popularity due to advancements in battery technology and
          growing environmental awareness
        </p>
      </div>

      {/* ─── Auto-Sliding Car Carousel ─── */}
      <div
        className="relative overflow-hidden"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div
          ref={trackRef}
          className="flex gap-6 py-6"
          style={{ width: "max-content" }}
        >
          {allCars?.map((car, i) => (
            <CarCard key={i} car={car} />
          ))}
        </div>
      </div>
       <div
          className="flex justify-center animate-fade-in"
          style={{ animationDelay: "800ms" }}
        >
          <button
            onClick={() => navigate(`/car`)}
            className="group relative px-8 py-3.5 bg-gray-900 text-white rounded-full font-semibold shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
          >
            <span className="relative z-10 flex items-center space-x-2">
              <span>View All</span>
              <svg
                className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
        </div>
    </div>
  );
}

function CarCard({ car }) {
  return (
    <div
      className="group relative flex-shrink-0 w-64 rounded-3xl bg-gray-200 transition-all duration-500 hover:-translate-y-3 hover:shadow-2xl cursor-pointer overflow-hidden"
      style={{ "--car-color": car.color }}
    >
      {/* Popular badge */}
      {/* {car.tag && (
        <div className="absolute top-3 right-3 z-10 bg-amber-400 text-slate-900 text-xs font-black px-3 py-1 rounded-full shadow-lg animate-pulse">
          {car.tag}
        </div>
      )} */}

      {/* Glow bg */}
      <div
        className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500 rounded-3xl"
        style={{
          background: `radial-gradient(circle at 50% 60%, ${car.color}, transparent 70%)`,
        }}
      />

      {/* Car image area */}
      <div className="relative h-40 w-full flex items-center justify-center px-4 pt-6">
        <div
          className="absolute bottom-0 left-1/2 -translate-x-1/2  h-8 rounded-full blur-xl opacity-0 group-hover:opacity-60 transition-opacity duration-500 w-full"
          style={{ backgroundColor: car.color }}
        />
        <img
          src={car.img}
          alt={car.name}
          className="w-full h-full object-cover drop-shadow-2xl transition-transform duration-500 group-hover:scale-110"
          onError={(e) => {
            // Fallback SVG car
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "block";
          }}
        />
        <svg
          style={{ display: "none" }}
          className="w-36 h-24"
          viewBox="0 0 200 120"
          fill="none"
        >
          <rect
            x="20"
            y="50"
            width="160"
            height="50"
            rx="10"
            fill={car.color}
            opacity="0.8"
          />
          <path d="M40 50 L60 20 L140 20 L160 50Z" fill={car.color} />
          <circle
            cx="55"
            cy="100"
            r="18"
            fill="#1e293b"
            stroke={car.color}
            strokeWidth="4"
          />
          <circle
            cx="145"
            cy="100"
            r="18"
            fill="#1e293b"
            stroke={car.color}
            strokeWidth="4"
          />
          <circle cx="55" cy="100" r="8" fill={car.color} opacity="0.5" />
          <circle cx="145" cy="100" r="8" fill={car.color} opacity="0.5" />
          <rect
            x="65"
            y="25"
            width="30"
            height="22"
            rx="4"
            fill="#94a3b8"
            opacity="0.4"
          />
          <rect
            x="103"
            y="25"
            width="30"
            height="22"
            rx="4"
            fill="#94a3b8"
            opacity="0.4"
          />
        </svg>
      </div>

      {/* Name & bottom */}
      <div className="px-4 pb-5 pt-2 text-center">
        <span className=" font-bold text-base tracking-tight capitalize">{car.name}</span>
        <div
          className="mt-3 h-0.5 w-0 group-hover:w-full mx-auto transition-all duration-500 rounded-full"
          style={{ backgroundColor: car.color }}
        />
      </div>
       
    </div>
   
  );
}
